// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../common.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../ng-override.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#vueMain {
  position: relative;
  flex-direction: column;
}
#vueMain>*:not(#content) {
  font-family: 'Roboto', sans-serif;
}
#vueMain>*:not(#content) ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
#app,
#content,
#vueMain {
  display: flex;
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/App.vue"],"names":[],"mappings":";AAuBA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AAEA;EACE,iCAAiC;AACnC;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AAEA;;;EAGE,aAAa;EACb,OAAO;AACT","sourcesContent":["<script setup lang=\"ts\">\r\nimport ExtensionBar from \"#src/components/ExtensionBar.vue\";\r\nimport Tutorial from \"#src/components/Tutorial.vue\";\r\n\r\nimport { loaded } from \"#src/store.js\";\r\n</script>\r\n\r\n<template>\r\n  <div id=\"vueMain\">\r\n    <div v-if=\"loaded\" class=\"ng-extend\">\r\n      <Tutorial />\r\n      <ExtensionBar />\r\n    </div>\r\n    <div id=\"content\">\r\n      <div id=\"neuroglancer-container\"></div>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<style>\r\n@import \"../common.css\";\r\n@import \"../ng-override.css\";\r\n\r\n#vueMain {\r\n  position: relative;\r\n  flex-direction: column;\r\n}\r\n\r\n#vueMain>*:not(#content) {\r\n  font-family: 'Roboto', sans-serif;\r\n}\r\n\r\n#vueMain>*:not(#content) ul {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n#app,\r\n#content,\r\n#vueMain {\r\n  display: flex;\r\n  flex: 1;\r\n}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
